export const FADE_DURATION_FAST = 0.2
export const FADE_DURATION_SLOW = 0.7
